import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import TransferScheduleDetailCard from '~/components/transferScheduleDetailCard/transferScheduleDetailCard';
import TransferScheduleSummaryCard from '~/components/transferScheduleSummaryCard/transferScheduleSummaryCard';
import TransferScheduleTransfers from '~/components/transferScheduleTransfers/transferScheduleTransfers';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getTransferScheduleQuery = gql`
  query transferSchedule($id: Int!) {
    transferSchedule(id: $id) {
      id
      name
      description
      transfers {
        id
        name
        type
        tankType
        notes
        vesselDescription
        days
        stepNumber
        requiresDutyPaid
        shouldAutocomplete
        location {
          name
        }
        tank {
          name
        }
      }
    }
  }
`;

const TransferSchedule = ({ onCompleted, id }) => (
  <Query
    query={getTransferScheduleQuery}
    variables={{ id }}
    onCompleted={onCompleted}
    fetchPolicy={'cache-and-network'}
  >
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { transferSchedule } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <TransferScheduleDetailCard {...transferSchedule} />
            <h3 className="h4 h-auto mv4">Transfer steps</h3>
            <TransferScheduleTransfers transfers={transferSchedule.transfers} />
          </div>
          <div className="flex-1">
            <TransferScheduleSummaryCard {...transferSchedule} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(TransferSchedule);



// WEBPACK FOOTER //
// ./src/containers/transferSchedule/transferSchedule.jsx